import { PageHeader, Section } from "@/components/site/PageChrome";

/** Renders a legal/policy document from structured sections. */
export function LegalDoc({ eyebrow, title, updated, intro, sections }) {
  return (
    <>
      <PageHeader eyebrow={eyebrow} title={title} subtitle={intro} />
      <Section>
        <div className="max-w-3xl mx-auto">
          {updated && <div className="text-sm text-[#78716C] mb-8">Last updated: {updated}</div>}
          <div className="space-y-8">
            {sections.map((s, i) => (
              <div key={i}>
                <h2 className="text-xl md:text-2xl font-bold text-[#1A1918]">{i + 1}. {s.h}</h2>
                {s.p && s.p.map((para, j) => (
                  <p key={j} className="mt-3 text-[#4A4846] leading-relaxed">{para}</p>
                ))}
                {s.list && (
                  <ul className="mt-3 space-y-2">
                    {s.list.map((li, j) => (
                      <li key={j} className="flex gap-2 text-[#4A4846]">
                        <span className="text-[#FF5A00] mt-1">•</span> <span>{li}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
          <div className="mt-12 rounded-2xl bg-[#FFF9F5] border border-[#EBE8E3] p-6 text-sm text-[#4A4846]">
            Questions about this policy? Email us at <a href="mailto:hello@time2cash.co" className="text-[#FF5A00] font-semibold">hello@time2cash.co</a>.
          </div>
        </div>
      </Section>
    </>
  );
}
